import * as ActionTypes from '../../constants/statistics/StatisticsActionTypes';

export const setInit = () => ({
  type: ActionTypes.INIT_ALL_OF_STORE
});

/**
 * 활성화된 날짜 변경
 * @param activeDate
 * @returns {{type: string, activeDate: *}}
 */
export const setActiveDate = (activeDate) => ({
  type: ActionTypes.SET_ACTIVE_DATE,
  activeDate
});

/**
 * 활성화된 날짜 타입 변
 * @param activeDateType
 * @returns {{type: string, activeDateType: *}}
 */
export const setActiveDateType = (activeDateType) => ({
  type: ActionTypes.SET_ACTIVE_DATE_TYPE,
  activeDateType
});

/**
 * 최소 날짜값
 * @param minDate
 * @returns {{type: string, minDate: *}}
 */
export const setMinDate = (minDate) => ({
  type: ActionTypes.SET_MIN_DATE,
  minDate
});

/**
 * hover index
 * @param hoverDateIndex
 * @returns {{type: string, hoverDateIndex: *}}
 */
export const setHoverDateIndex = (hoverDateIndex) => ({
  type: ActionTypes.SET_HOVER_DATE_INDEX,
  hoverDateIndex
});

/**
 * active index
 * @param activeDateIndex
 * @returns {{type: string, activeDateIndex: *}}
 */
export const setActiveDateIndex = (activeDateIndex) => ({
  type: ActionTypes.SET_ACTIVE_DATE_INDEX,
  activeDateIndex
});

/**
 * 전체 조회수 (게시글, 또는 블로그)
 * @param totalCount
 * @returns {{type: string, totalCount: *}}
 */
export const setTotalCount = (totalCount) => ({
  type: ActionTypes.SET_TOTAL_COUNT,
  totalCount
});

/**
 * 데이터를 호출할 기준 날짜
 * @param standardDate
 * @returns {{type: string, standardDate: *}}
 */
export const setStandardDate = (standardDate) => ({
  type: ActionTypes.SET_STANDARD_DATE,
  standardDate
});

/**
 * entryId
 * @param entryId
 * @returns {{type: string, entryId: *}}
 */
export const setEntryId = (entryId) => ({
  type: ActionTypes.SET_ENTRY_ID,
  entryId
});
